export enum PastelId {
  Peach = 'peach',
  Mint = 'mint',
  Sky = 'sky',
  Lavender = 'lavender',
  Butter = 'butter',
  Rose = 'rose',
}

export const PASTEL = {
  [PastelId.Peach]: '#F9D5C8',
  [PastelId.Mint]: '#CDEBDD',
  [PastelId.Sky]: '#CFE3F7',
  [PastelId.Lavender]: '#E1D8F5',
  [PastelId.Butter]: '#F8EBB8',
  [PastelId.Rose]: '#F7D3E3',
} as const satisfies Readonly<Record<PastelId, string>>

export const PASTEL_ORDER = Object.values(PastelId)

export function validateIllustrationPalette(): void {
  const ids = Object.values(PastelId)
  if (Object.keys(PASTEL).length !== ids.length) throw new Error('Illustration pastel palette is incomplete')
  for (const id of ids) {
    if (!/^#[\da-f]{6}$/i.test(PASTEL[id])) throw new Error(`Illustration pastel "${id}" must be a six-digit hex color`)
  }
}
